import type React from 'react';

import { Box } from '@mui/material';

import { SideBarGetSupport } from '@/layouts/private/sidebar/components/getSupport/SideBarGetSupport.comp.tsx';
import { Logo } from '@/layouts/private/sidebar/components/logo/Logo.comp';
import SideBarMenu from '@/layouts/private/sidebar/components/sideBarMenu/SideBarMenu.comp';
import { useResponsiveSideBar } from '@/layouts/private/sidebar/hooks/useResponsiveSideBar.ts';
import { getSideBarDrawerClasses } from '@/layouts/private/sidebar/SideBar.styles.ts';

/**
 * App-layout-only sidebar (OCD-308): bare screens (login, assessment detail)
 * never mount this component because they live under BareLayout.
 */
const SideBar: React.FC = () => {
  const { handleMouseEnter, handleMouseLeave, isCollapsed, isHovered, showExpandedContent } =
    useResponsiveSideBar();

  return (
    <Box
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={getSideBarDrawerClasses(isCollapsed, isHovered)}
    >
      <Box
        sx={{
          height: 'calc(100vh - 56px)',
          overflowX: 'hidden',
          overflowY: 'auto',
          pb: 1,
        }}
      >
        <Logo showExpandedContent={showExpandedContent} />
        <SideBarMenu showExpandedContent={showExpandedContent} />
      </Box>
      <Box
        sx={{
          backgroundColor: 'inherit',
          bottom: 0,
          boxShadow: '0 -1px 0 rgba(255, 255, 255, 0.1)',
          display: 'flex',
          justifyContent: 'center',
          position: 'sticky',
          py: 1,
        }}
      >
        <SideBarGetSupport showExpandedContent={showExpandedContent} />
      </Box>
    </Box>
  );
};

export default SideBar;
